import { gql } from 'graphql-request'

export namespace HomeLocationQueries {
  export const QUERY_KEY = 'getHomeLocations'

  export function getHomeLocations() {
    return gql`
      query homeLocations {
        homeLocations {
          id
          name
        }
      }
    `
  }
}
